"use client"


import { useMemo } from "react"
import { PreviewDetails } from "@/components/preview/PreviewDetails"
import { PreviewViewer } from "@/components/preview/PreviewViewer"
import type { PreviewData } from "@/lib/types"

interface PreviewLayoutProps {
    preview: PreviewData
    selectedSubPreview: PreviewData | null
    isEditing: boolean
    setIsEditing: (editing: boolean) => void
    editName: string
    setEditName: (name: string) => void
    editShareable: boolean
    setEditShareable: (shareable: boolean) => void
    editSubPreviewId: string | null
    editProjectId: string | null
    setEditProjectId: (id: string | null) => void
    editTags: string[]
    setEditTags: (tags: string[]) => void
    isSaving: boolean
    handleSaveChanges: () => void
    handleCancelEdit: () => void
    openDeleteDialog: () => void
    openUpdateImageModal: () => void
    isUpdatingImage: boolean
    formatDate: (date: string) => string
    compatible_sub_previews: any[]
    handleSubPreviewChange: (id: string | null) => void
}

const PreviewLayout = ({
    preview,
    selectedSubPreview,
    isEditing,
    setIsEditing,
    editName,
    setEditName,
    editShareable,
    setEditShareable,
    editSubPreviewId,
    editProjectId,
    setEditProjectId,
    editTags,
    setEditTags,
    isSaving,
    handleSaveChanges,
    handleCancelEdit,
    openDeleteDialog,
    openUpdateImageModal,
    isUpdatingImage,
    formatDate,
    compatible_sub_previews,
    handleSubPreviewChange,
}: PreviewLayoutProps) => {
    const previewDetailsProps = useMemo(() => ({
        preview,
        isEditing,
        setIsEditing,
        editName,
        setEditName,
        editShareable,
        setEditShareable,
        editSubPreviewId,
        editProjectId,
        setEditProjectId,
        editTags,
        setEditTags,
        isSaving,
        handleSaveChanges,
        handleCancelEdit,
        openDeleteDialog,
        openUpdateImageModal,
        isUpdatingImage,
        formatDate,
        compatible_sub_previews,
        handleSubPreviewChange,
        selectedSubPreview,
    }), [
        preview, isEditing, editName, editShareable, editSubPreviewId, 
        editProjectId, editTags, isSaving, selectedSubPreview, 
        compatible_sub_previews, formatDate
    ])

    const viewerProps = useMemo(() => ({ 
        preview, 
        SubPreview: selectedSubPreview 
    }), [preview, selectedSubPreview])

    return (
        <div className="flex flex-col space-y-6 lg:grid lg:grid-cols-5 lg:gap-8 lg:space-y-0">
            {/* Preview viewer - first on mobile, second on desktop */}
            <div className="order-1 lg:order-2 lg:col-span-3">
                <PreviewViewer {...viewerProps} />
            </div>
            
            {/* Preview details - second on mobile, first on desktop */}
            <div className="order-2 lg:order-1 lg:col-span-2">
                <PreviewDetails {...previewDetailsProps} />
            </div>
        </div>
    )
}

export default PreviewLayout
